import React from 'react';
import { useTheme } from '@/providers/ThemeProvider';

interface CardBaseProps {
  children?: React.ReactNode;
  className?: string;
  shadowType?: 'black' | 'gradient' | 'none' | 'color' | 'theme' | 'status' | 'template';
  shadowColor?: string;
  backgroundColor?: string;
  border?: boolean;
  borderColor?: string;
  [key: string]: unknown;
}

export default function CardBase({ 
  children, 
  className = '', 
  shadowType = 'theme', // Changed default to 'theme'
  shadowColor = '#000000',
  backgroundColor, 
  border = true,
  borderColor, // Remove hardcoded default
  ...props 
}: CardBaseProps) {
  const { effectiveTheme } = useTheme();
  
  const getShadowStyle = () => {
    switch (shadowType) {
      case 'gradient':
        return { background: "linear-gradient(116deg, var(--Purple-1, #6E35FF) 0%, #30E38D 54.16%)" };
      case 'color':
      case 'status':
      case 'template':
        // All use shadowColor prop
        return { background: shadowColor };
      case 'none':
        return { background: 'transparent' };
      case 'theme':
        // Use theme-aware shadow color
        return { background: effectiveTheme === 'dark' ? '#111111' : '#000000' };
      default: // 'black'
        return { background: "#000000" };
    }
  };

  const shadowStyle = getShadowStyle();

  // Theme-aware defaults
  const defaultBackgroundColor = backgroundColor || 'hsl(var(--card))';
  const defaultBorderColor = borderColor || 'hsl(var(--border))';

  return (
    <div className="relative w-full h-full min-h-[100px]" {...props}>
      {/* Shadow behind the box, offset to bottom and right */}
      <div 
        className="absolute top-1 left-1 w-full h-full rounded z-0" 
        style={shadowStyle}
      />
      {/* Main card */}
      <div 
        className={`relative w-full h-full rounded z-10 box-border ${border ? 'border' : ''} ${className}`}
        style={{ 
          backgroundColor: defaultBackgroundColor,
          borderColor: border ? defaultBorderColor : undefined
        }}
      >
        {children}
      </div>
    </div>
  );
}